import { XingletWrapper } from './xinglet-helpers';
import type { XingletInterface } from './xinglet-helpers';

export type PreferencesProps = {
  show: boolean;
  togglePreferences: () => void;
};

export type PreferencesXinglet = XingletInterface<PreferencesProps>;
export const Preferences = XingletWrapper<PreferencesProps>(
  '@xing-com/crate-lebenslauf-components-preferences'
);
